<template>
  <span class="alice-client-chip">
    <span class="alice-client-chip__swatch" :style="{ background: color }" />
    <span class="alice-client-chip__name">{{ name }}</span>
  </span>
</template>

<script>
export default {
  name: "AliceClientChip",
  props: {
    name: { type: String, required: true },
    color: { type: String, default: "var(--vp-grijs-40)" },
  },
};
</script>

<style scoped>
.alice-client-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-family: var(--font-ui);
  font-size: 13px;
  font-weight: 600;
  color: var(--fg-2);
  white-space: nowrap;
  min-width: 0;
}
.alice-client-chip__swatch {
  width: 10px;
  height: 10px;
  flex-shrink: 0;
  border-radius: 0;
}
.alice-client-chip__name {
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
